import WebApp from "@twa-dev/sdk";

/**
 * Get an item from cloud storage
 * @description The key should contain 1-128 characters, only A-Z, a-z, 0-9, _ and - are allowed.
 * @url https://docs.twa.dev/cloud-storage
 * @param key {string} - The key of the item to get
 */
export async function getCloudStorageItem(
  key: string,
): Promise<string | undefined> {
  return new Promise((resolve) => {
    WebApp.CloudStorage.getItem(key, (error, value) => {
      if (error) {
        console.error(`Error getting ${key} from cloud storage`);
        resolve(undefined);
      } else {
        resolve(value);
      }
    });
  });
}

export async function setCloudStorageItem(
  key: string,
  value: string,
): Promise<boolean> {
  return new Promise((resolve) => {
    WebApp.CloudStorage.setItem(key, value, (error) => {
      if (error) {
        console.error(`Error setting ${key} in cloud storage`);
        resolve(false);
      } else {
        resolve(true);
      }
    });
  });
}
